import { EMPTY_ARRAY_LENGTH, featureFlagsEnums } from "../../constants";
import { StatusIndicator } from "../../../../shared";
import { isFeatureActive } from "./utility";
import FeatureFlagEditButton from "./featureFlagEditButton";

const FeatureFlagExpandedRow = ({ data, onEditStore }) => {
  return (
    <div className="h-50 overflow-auto my-3">
      {data.stores?.length > EMPTY_ARRAY_LENGTH ? (
        <div className="locations-container sidebar-green bg-white">
          {data.stores.map((store) => {
            const rowFeature = store?.storeFeatures || [];

            return (
              <div
                key={store.storeId}
                data-testid="store-row"
                className="d-flex p-2 py-3 ps-3"
              >
                <div className="store-feature-flag-name">
                  <p className="mb-0">{store.storeName}</p>
                </div>
                <div data-testid="store-ai-reply" className="store-feature-box">
                  <StatusIndicator
                    isActive={isFeatureActive(
                      rowFeature,
                      featureFlagsEnums.AI_REPLY
                    )}
                    className="px-0"
                  />
                </div>
                <div data-testid="store-inbox" className="store-feature-box">
                  <StatusIndicator
                    isActive={isFeatureActive(
                      rowFeature,
                      featureFlagsEnums.INBOX
                    )}
                    className="px-0"
                  />
                </div>
                <div data-testid="store-nps-first" className="store-feature-box">
                  <StatusIndicator
                    isActive={isFeatureActive(
                      rowFeature,
                      featureFlagsEnums.NPS_FIRST
                    )}
                    className="px-0"
                  />
                </div>
                <div data-testid="store-inStore" className="store-feature-box">
                  <StatusIndicator
                    isActive={isFeatureActive(
                      data.brandFeatures,
                      featureFlagsEnums.IN_STORE
                    )}
                    className="px-0"
                  />
                </div>
                <div>
                  <FeatureFlagEditButton
                    testId="store-edit-icon"
                    onClick={() =>
                      onEditStore({
                        storeDetail: store,
                        isStoreUpdate: true,
                        brandId: data?.brandId,
                        storeFeatures: rowFeature,
                        brandName: data?.brandName,
                      })
                    }
                  />
                </div>
              </div>
            );
          })}
        </div>
      ) : (
        <p className="text-center mb-0">No Store Found</p>
      )}
    </div>
  );
};

export default FeatureFlagExpandedRow;
